export const LOG_LOGIN = "LOGIN";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CALCULATE_QUOTE = "CALCULATE_QUOTE";
